module.exports = __webpack_public_path__ + "img/cooperative-hero.486a1231.png";